import {
  fetchJson,
  UPDATE_ITEM_QUANTITY,
  DELETE_ITEM,
  UPDATING_ITEM_QUANTITY_ASYNC,
  DELETING_ITEM_ASYNC,
  UPDATE_ORDER_TYPE,
  UPDATE_ORDER_TYPE_ASYNC,
  UPDATE_CART_ITEMS,
  UPDATING_CART_ITEMS_ASYNC,
} from '../../GlobalStateContainer'

import {
  notifyError
} from '../UserMessaging'

import {
  TranslationUtility
} from '../../../util/translationUtility'

/* CART */
export function updateItemQuantity(itemId, newQuantity) {
  return { type: UPDATE_ITEM_QUANTITY, itemId, newQuantity }
}

export function deleteItem(itemId) {
  return { type: DELETE_ITEM, itemId }
}

const onUpdateQuantitySuccess = ({ error, message }, { id, qty }, getState) => {
  if (!error) {
    return updateItemQuantity(id, qty);
  } else {
    return notifyError('Updating the quantity failed. Please try again or contact customer service.', message);
  }
}

const notifyUpdatingItem = function ({ id, qty }) {
  return { type: UPDATING_ITEM_QUANTITY_ASYNC, id, qty };
}
const updateItemQuantityAsyncSpec = {
  endpoint: (state) => state.constants.navigation.updateItemQuantityEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: notifyUpdatingItem,
  extract: (response) => response.json(),
  onSuccess: onUpdateQuantitySuccess,
  onError: (diagMsg) => notifyError('An error occurred updating the quantity for your item', diagMsg)
}

export const updateItemQuantityAsync = fetchJson(updateItemQuantityAsyncSpec)

const ondeleteSuccess = ({ error, message }, { id }, getState) => {
  if (!error) {
    return deleteItem(id);
  } else {
    return notifyError('Deleting the item failed. Please try again or contact customer service.', message);
  }
}

const deleteItemAsyncSpec = {
  endpoint: (state) => state.constants.navigation.deleteItemEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: ({ id }) => ({ type: DELETING_ITEM_ASYNC, id }),
  extract: (response) => response.json(),
  onSuccess: ondeleteSuccess,
  onError: (diagMsg) => notifyError('An error occurred updating the for your item', diagMsg)
}

export const deleteItemAsync = fetchJson(deleteItemAsyncSpec)

const onGetOrderTypeSuccess = (responseObject, unused, getState) => {
    const state = getState();
    if(responseObject === state.constants.onlineOrderOrderType || responseObject === state.constants.onlineQuoteOrderType) {
      return { 
        type: UPDATE_ORDER_TYPE, 
        localizationItems: state.constants.localizationItems, 
        orderType: responseObject,
        onlineOrderOrderType: state.constants.onlineOrderOrderType,
        onlineQuoteOrderType: state.constants.onlineQuoteOrderType
      };
    } else {
    return notifyError("We could not confirm your order type. Please refresh and try again.",
    responseObject);
  }
}

const getOrderTypeSpec = {
  endpoint: (state) => state.constants.navigation.getOrderTypeEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: () => ({ type: UPDATE_ORDER_TYPE_ASYNC }),
  extract: (response) => response.text(),
  onSuccess: onGetOrderTypeSuccess,
  onError: (diagMsg) => notifyError("An error occurred communicating with the server", diagMsg)
}

export const getOrderTypeAsync = fetchJson(getOrderTypeSpec);

const fetchCartItemsSpec = {
  endpoint: (state) => state.constants.navigation.getCartItemsEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin'},
  notify: () => ({type: UPDATING_CART_ITEMS_ASYNC}),
  extract: (response) => response.json(),
  onSuccess: (responseObject, unused, getState) => {
    if (typeof(responseObject) === 'object') {
      return {
        type: UPDATE_CART_ITEMS,
        cartItems: responseObject.Items
      }
    } else {
      return notifyError("We could not update the cart. Please reload the page and try again", responseObject)
    }
  },
  onError: (diagMsg) => notifyError("An error occurred communicating with the server", diagMsg)
}

export const fetchCartItems = fetchJson(fetchCartItemsSpec)



// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Cart/cartActionCreators.js